import { useTranslation } from '@packlink/translation-provider';
import * as qs from 'qs';
import { Address } from '@packlink/packlink-sdk';
import { WithCommonProps } from '@shipengine/giger';

export type PrintInStoreInfoProps = WithCommonProps<{
    address?: Address;
    printInStoreUrl?: string;
}>;

export function PrintInStoreInfo({ address, printInStoreUrl, ...props }: PrintInStoreInfoProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <p
            dangerouslySetInnerHTML={{
                __html: t('additional-services.print-in-store.find-location', {
                    href: printInStoreUrl || getFindLocationUrl(address),
                }),
            }}
            {...props}
        />
    );
}

export const getFindLocationUrl = (from?: Address): string => {
    return `${config.carriers.hermes.page.find_location}?${qs.stringify({
        printinstore: true,
        search: from?.zipCode,
    })}`;
};
